import { getClickIdFromSession, getClickIdFromUrl } from 'services/TikTok';

const CONSENT_EVENTS = ['CookiebotOnLoad', 'CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'] as const;

let isAwaitingConsent = false;
let landingAdClickId: string | null = null;

const keepOnceGranted = () => {
  if (isAwaitingConsent && window.Cookiebot?.consent.marketing) {
    isAwaitingConsent = false;

    if (landingAdClickId) {
      window.gt.ttclid = landingAdClickId;
    } else {
      getClickIdFromSession()
        .then((sessionAdClickId) => {
          window.gt.ttclid = sessionAdClickId;
        })
        .catch(() => undefined);
    }
  }
};

export const startAdClickIdKeeper = () => {
  isAwaitingConsent = true;
  // Noted as the page loads, so a client-side navigation before consent cannot change it
  landingAdClickId = getClickIdFromUrl();
  CONSENT_EVENTS.forEach((event) => window.addEventListener(event, keepOnceGranted));
  keepOnceGranted();
};
